import { createAsyncAction } from 'typesafe-actions';
import {
  GetBanksSuccessPayload,
  CreateBankRequest,
  CreateBankSuccessPayload,
  UpdateBankRequest,
  UpdateBankSuccessPayload,
  GetBankEntitiesSuccessPayload,
  GetCdsCurvesSuccessPayload,
  GetClientBankAccountsSuccessPayload,
  GetCounterpartyBanksSuccessPayload,
  GetCreditRatingsSuccessPayload,
  BankEntity,
  GetCsaThresholdsSuccessPayload,
  CreateCsaThresholdRequest,
  CreateCsaThresholdSuccessPayload,
  UpdateCsaThresholdRequest,
  UpdateCsaThresholdSuccessPayload,
  DeleteCsaThresholdSuccessPayload,

} from '../types';
import  {NewEntityValues} from '@/pages/Banks/components/FundLevelAdminTable/components/EntityModal/types';




export const getBanks = createAsyncAction(
  'banks/getBanks/request',
  'banks/getBanks/success',
  'banks/getBanks/failure',
)<undefined, GetBanksSuccessPayload, undefined>();

export const createBank = createAsyncAction(
  'banks/createBank/request',
  'banks/createBank/success',
  'banks/createBank/failure'
)<CreateBankSuccessPayload, CreateBankRequest, string>();

export const updateBank = createAsyncAction(
  'banks/updateBank/request',
  'banks/updateBank/success',
  'banks/updateBank/failure'
)<UpdateBankRequest, UpdateBankSuccessPayload, string>();

export const getBankEntities = createAsyncAction(
  'bankEntities/getOther/request',
  'bankEntities/getOther/success',
  'bankEntities/getOther/failure'
)<undefined, GetBankEntitiesSuccessPayload, string>();

export const createBankEntity = createAsyncAction(
  'banks/createBankEntity/request',
  'banks/createBankEntity/success',
  'banks/createBankEntity/failure'
)<{ data: BankEntity }, NewEntityValues, string>();

export const updateBankEntity = createAsyncAction(
  'banks/updateBankEntity/request',
  'banks/updateBankEntity/success',
  'banks/updateBankEntity/failure'
)<{ data: BankEntity }, { entityId: string | number; values: NewEntityValues }, string>();

export const getCdsCurves = createAsyncAction(
  'cdsCurves/get/request',
  'cdsCurves/get/success',
  'cdsCurves/get/failure'
)<undefined, GetCdsCurvesSuccessPayload, string>();

export const getClientBankAccounts = createAsyncAction(
  'clientBankAccounts/get/request',
  'clientBankAccounts/get/success',
  'clientBankAccounts/get/failure'
)<undefined, GetClientBankAccountsSuccessPayload, string>();

export const getCounterpartyBanks = createAsyncAction(
  'counterpartyBanks/get/request',
  'counterpartyBanks/get/success',
  'counterpartyBanks/get/failure'
)<undefined, GetCounterpartyBanksSuccessPayload, string>();

export const getCreditRatings = createAsyncAction(
  'creditRatings/get/request',
  'creditRatings/get/success',
  'creditRatings/get/failure'
)<undefined, GetCreditRatingsSuccessPayload, string>();

export const getCsaThresholds = createAsyncAction(
  'csaThresholds/get/request',
  'csaThresholds/get/success',
  'csaThresholds/get/failure'
)<undefined, GetCsaThresholdsSuccessPayload, string>();

export const createCsaThreshold = createAsyncAction(
  'csaThresholds/create/request',
  'csaThresholds/create/success',
  'csaThresholds/create/failure'
)<CreateCsaThresholdRequest, CreateCsaThresholdSuccessPayload, string>();

export const updateCsaThreshold = createAsyncAction(
  'csaThresholds/update/request',
  'csaThresholds/update/success',
  'csaThresholds/update/failure'
)<UpdateCsaThresholdRequest, UpdateCsaThresholdSuccessPayload, string>();

export const deleteCsaThreshold = createAsyncAction(
  'csaThresholds/delete/request',
  'csaThresholds/delete/success',
  'csaThresholds/delete/failure'
)<{ id: number }, DeleteCsaThresholdSuccessPayload, string>();


